module.exports = __webpack_public_path__ + "assets/img/110f010623d5a07d795d90070bd2602d.png";